// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"2fe06ea7","315":"4c80056d","409":"43480aea","631":"c1d664be","771":"dd177c54","774":"bb020c28","787":"cdff5a4b"}[chunkId] + ".chunk.js";
};